<template>
    <div class="member-header">
        <div class="clearfix">
            <h3 class="header-h3">MyZFX</h3>
            <template v-if="$store.state.info.certification">
                <div class="status-text">
            <span class="status"
                  :class="{
              'red':Number($store.state.info.certification.identity_auth_status)===0||Number($store.state.info.certification.identity_auth_status)===1||Number($store.state.info.certification.identity_auth_status)===3,
              'orange':Number($store.state.info.certification.identity_auth_status)===2,
              'green':Number($store.state.info.certification.identity_auth_status)===4
              }"
            >
              ID {{verify_info[Number($store.state.info.certification.identity_auth_status)]}}
              </span>
                    <span class="status"
                          :class="{
              'red':Number($store.state.info.certification.address_auth_status)===0||Number($store.state.info.certification.address_auth_status)===1||Number($store.state.info.certification.address_auth_status)===3,
              'orange':Number($store.state.info.certification.address_auth_status)===2,
              'green':Number($store.state.info.certification.address_auth_status)===4,
               }"
                    >
              Address {{verify_info[Number($store.state.info.certification.address_auth_status)]}}
            </span>
                </div>
            </template>
            <div class="header-right">
                <div class="header-right-btn">
                    <span>{{this.$store.state.info.email}}</span>
                    <i class="iconfont icon-xiangxiajiantou"></i>
                </div>
                <div class="down-model">
                    <ul class="info">
                        <li>LOGIN</li>
                        <li style="color: #0A95FF;">{{this.$store.state.info.email}}</li>
                    </ul>
                    <ul>
                        <li @click="_logout">SIGN OUT</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { logout, isLogin } from 'service/login'
  import { CODE_OK } from '../../utils/const'

  export default {
    data () {
      return {
        verify_info: [
          'Not verified',
          'Not verified',
          'Verifying',
          'Verification failed',
          'verified '
        ]
      }
    },
    methods: {
      _logout () {
        logout().then(() => {
          localStorage.uk_token = ''
          this.$router.push({name: 'login'})
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .member-header {
        height: 91px;
        background-color: #ffffff;
        box-shadow: 0px 3px 8px 0px rgba(213, 213, 213, 0.42);
        .header-h3 {
            font-size: 32px;
            float: left;
            font-weight: normal;
            font-stretch: normal;
            line-height: 35px;
            letter-spacing: 0px;
            color: #444444;
            padding: 30px 0 0 36px;
        }
        .status-text {
            .status {
                display: inline-block;
                vertical-align: middle;
                margin-right: 20px;
                color: #fd8421;
                &:before {
                    content: '';
                    width: 10px;
                    height: 10px;
                    background-color: #fd8421;
                    display: inline-block;
                    border-radius: 10px;
                    margin-right: 10px;
                }

                &.orange {
                    color: #fd8421;
                    &:before {
                        background-color: #fd8421;
                    }
                }

                &.red {
                    color: #e03d41;
                    &:before {
                        background-color: #e03d41;
                    }
                }

                &.green {
                    color: #40a83a;
                    &:before {
                        background-color: #40a83a;
                    }
                }
            }
            float: left;
            padding: 30px 0 0 35px;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 35px;
            letter-spacing: 0px;
            color: #fd8421;
        }
        .header-right {
            float: right;
            position: relative;
            .header-right-btn {
                height: 90px;
                line-height: 90px;
                padding: 0 25px;
                font-size: 14px;
                color: #0A95FF;
                cursor: pointer;
                i {
                    padding-left: 20px;
                }
            }
            .down-model {
                position: absolute;
                display: none;
                top: 88px;
                right: 0;
                padding: 20px;
                z-index: 100;
                border-bottom-left-radius: 3px;
                border-bottom-right-radius: 3px;
                background: #ffffff;
                box-shadow: -2px 2px 5px rgba(0, 0, 0, 0.1), 0 0 0 rgba(0, 0, 0, 0.1),
                0 2px 5px rgba(0, 0, 0, 0.1), 0 2px 5px rgba(0, 0, 0, 0.1); //右边阴影
                /* filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1));
                -webkit-filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1)); */
                ul {
                    li {
                        line-height: 35px;
                        cursor: pointer;
                    }
                }
                .info {
                    padding-bottom: 10px;
                    margin-bottom: 10px;
                    border-bottom: 1px solid #ddd;
                }
            }
            &:hover {
                .down-model {
                    display: block;
                }
            }
        }
    }
</style>
